import type { ReactNode } from "react"
import { cn } from "../../../lib/utils"

export interface AppShellProps {
  sidebar?: ReactNode
  header?: ReactNode
  /** Content rendered in the sticky top bar on mobile (hidden on md+). */
  mobileHeader?: ReactNode
  children: ReactNode
  className?: string
}

export function AppShell({ sidebar, header, mobileHeader, children, className }: AppShellProps) {
  return (
    <div className={cn("flex h-screen overflow-hidden bg-[var(--background)]", className)}>
      {sidebar}
      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Mobile top bar — hamburger + logo. Hidden on desktop (md+). */}
        {mobileHeader && (
          <div className="flex h-14 shrink-0 items-center gap-3 border-b border-[var(--border)] bg-[var(--sidebar)] px-3 md:hidden">
            {mobileHeader}
          </div>
        )}
        {header && (
          <div className="shrink-0">
            {header}
          </div>
        )}
        <main className="flex min-h-0 flex-1 flex-col overflow-hidden bg-[var(--content-background)]">{children}</main>
      </div>
    </div>
  )
}
